import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

// constants
import LocalStrings from '../../assets/languages';
import Loader from './Loader';

// files
import FourZeroFourPNG from '../../assets/img/placeholders/404.png';
import NoAccess from '../../assets/img/no-content/noAccess.png';

const CONTENT_TYPES = {
  none: '',
  noPage: 'noPage',
  wrong: 'wrong',
  restrict: 'restrict',
  unpublished: 'unpublished'
};

const PageNotFound = props => {
  const {
    // state
    deviceSize,
    userAccessByRole,
    appFeaturesList,
    unpublishedEvent = false,
    preparingApp = false,

    // component
    noPage = false
  } = props;
  const location = useLocation();
  const history = useHistory();
  const [contentType, setContentType] = useState(CONTENT_TYPES.none);

  useEffect(() => {
    if (noPage) {
      setContentType(CONTENT_TYPES.noPage);
    } else if (!unpublishedEvent) {
      let allowedPaths = [];
      _.map(appFeaturesList, route => allowedPaths.push(route.path));

      if (!_.includes(allowedPaths, location.pathname))
        setContentType(CONTENT_TYPES.wrong);
      else if (!_.isEmpty(userAccessByRole?.features)) {
        let selectedRoute = _.find(appFeaturesList, feature =>
          _.isEqual(feature.path, location.pathname)
        );

        if (!_.isEmpty(selectedRoute)) setContentType(CONTENT_TYPES.restrict);
      }
    } else setContentType(CONTENT_TYPES.unpublished);
  }, [userAccessByRole]);

  return (
    <div
      className="no-content-message d-flex flex-column justify-content-center align-items-center"
      style={{ height: deviceSize.height - 137, gap: 8 }}
    >
      {!_.isEmpty(contentType) && !preparingApp ? (
        <>
          {/* - Place holder image - */}
          <img
            className=""
            src={
              contentType === CONTENT_TYPES.restrict
                ? NoAccess
                : FourZeroFourPNG
            }
            style={{ height: 'auto', width: 150 }}
          />

          {/* - Label text - */}
          <span className="custom-text8-medium-primary">
            {contentType === CONTENT_TYPES.restrict
              ? LocalStrings.dynamic.kAccessDenied
              : contentType === CONTENT_TYPES.unpublished
              ? LocalStrings.dynamic.kEventNotPublished
              : LocalStrings.dynamic.kNoPage}
          </span>

          {/* - Description text - */}
          {contentType !== CONTENT_TYPES.unpublished && (
            <span className="custom-text9-normal-secondary">
              {contentType === CONTENT_TYPES.restrict
                ? LocalStrings.dynamic.kAccessDeniedDesc
                : LocalStrings.dynamic.kNoPageDesc}
            </span>
          )}

          {/* - Understood button for restricted - */}
          {_.includes(
            [CONTENT_TYPES.restrict, CONTENT_TYPES.noPage],
            contentType
          ) ? (
            <button
              className="custom-button-primary-md"
              onClick={() => history.push('/overview')}
            >
              {LocalStrings.dynamic.kAccessUnderstand}
            </button>
          ) : (
            ''
          )}
        </>
      ) : (
        <Loader />
      )}
    </div>
  );
};

const mapStateToProps = state => {
  const preparingApp =
    !_.isEmpty(state.session?.sessionToken) &&
    _.isEmpty(state.appFeaturesListReducer);

  return {
    deviceSize: state.deviceSize,
    userAccessByRole: state.userAccessByRole,
    appFeaturesList: state.appFeaturesListReducer,
    preparingApp
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PageNotFound);
